import { Component, OnInit, OnDestroy } from '@angular/core';
import { AdDataService } from '../services/addata.service';
import { UserdataService } from '../services/userdata.service';
import { Router } from '@angular/router';
import { ThrowStmt } from '@angular/compiler';
import { environment } from '../app.constant';
import { Fileservice } from '../services/fileservice.service';
import { AdbookingService } from '../services/adbooking.service';

@Component({
  selector: 'app-adsummary1',
  templateUrl: './adsummary1.component.html',
  styleUrls: ['./adsummary1.component.css']
})
export class Adsummary1Component implements OnInit, OnDestroy {
  displayadModel = {
    country: null,
    free: null,
    location: null,
    frees: null,
    freedays: null,
    adcategory: null,
    choosedAd: null,
    customradio: null,
    basicrate: null,
    widthinput: null,
    heightinput: null,
    adsizeinsqcm: null,
    uploadbtn: null,
    adsize: null,
    adcost: null,
    adContent: null,
    adContentPreview: null,
    igst: null,
    cgst: null,
    sgst: null,
    totalCost: null,
    imagename: null,
    adtype: null,
    adpage: null,
    flagupload: null,
    flagdate: null,
    noOfAdDays: null,
    noofdays: null,
    email: null,
    addate: null,
    trxnid: null,
    fileData: null,
    uploadedFilePath: null,
    selectedDate: null,
    touched: null,
    custid: null,
    orderid: null,
    guestid: null,
    address: null,
    isGuest: null,
    username: null,
    mobilenumber: null,
    boxcharge: null,
    postalcharge: null,
    state: null,
    zip: null,
    city: null,
  };

  adDetails = {
    boxcharge: '',
    postalcharge: '',
    free: '',
    frees: '',
    freedays: '',
    adcategory: '',
    location: '',
    choosedAd: '',
    customradio: '',
    basicrate: '',
    widthinput: '',
    heightinput: '',
    adsizeinsqcm: '',
    uploadbtn: '',
    adContent: '',
    adContentPreview: '',
    adsize: '',
    adcost: '',
    gst: 0,
    totalCost: '',
    imagename: '',
    adtype: '',
    adpage: '2nd Page',
    noOfAdDays: '',
    noofdays: '',
    email: '',
    addate: '',
    trxnid: '',
    flagupload: true,
    flagdate: true,
    fileData: File = null,
    uploadedFilePath: '',
    selectedDate: [] = '',
    touched: ''
  };


  selectedDates: any;

  cost: any;
  user: any;
  free: any;
  frees: any;
  freedays: string;
  merchantId = '258936';
  tid: any;
  torderid: any;
  // requiredParam = {
  //   billing_name: null,
  //   billing_address: 'nvl',
  //   billing_city: 'nvl',
  //   billing_state: 'nvl',
  //   billing_zip: '90',
  //   billing_country: 'nvl',
  //   billing_tel: null,
  //   billing_email: null
  // };
  ccaResponseurl: string;
  ccaRequesturl: string;
  ccaCancelPaymentUrl: string;
  isUserAddressValid: boolean;


  constructor(
    private addata: AdDataService,
    private userdataservice: UserdataService,
    private router: Router,
    private fileservice: Fileservice,
    private adbookingService: AdbookingService,
    private userdata: UserdataService
  ) {
    this.tid = new Date().getTime();
    this.torderid = 'TORID' + this.tid;
    this.ccaResponseurl = environment.apiHost + '/postrespccav';
    this.ccaRequesturl = environment.apiHost + '/posttestccav';
    this.ccaCancelPaymentUrl = environment.apiHost + '/ccaCancelPayment';
    this.user = this.userdataservice.getUserData();

    if (this.user && Boolean(this.user.address) && Boolean(this.user.city) && Boolean(this.user.state) && Boolean(this.user.zip)) {
      this.isUserAddressValid = true;
    } else {
      this.isUserAddressValid = false;
    }
    // this.requiredParam.billing_email = this.userdataservice.getUserData().email;
    // this.requiredParam.billing_name = this.userdataservice.getUserData().username;
    // this.requiredParam.billing_tel = this.userdataservice.getUserData().mobilenumber;
    this.displayadModel = JSON.parse(sessionStorage.getItem('Array'));
    // const obj=this.addata.getAdData();
    // obj.adsummary=this.displayadModel;
    // console.log(obj.adsummary);
    // console.log( this.displayadModel);
    // this.noofdays = sessionStorage.getItem("noOfAdDays");
    // console.log(this.noofdays);
    // this.displayadModel.noofdays = this.noofdays;
    this.selectedDates = sessionStorage.getItem('selectedDate');
    this.free = sessionStorage.getItem('free');
    this.frees = sessionStorage.getItem('frees');
    this.freedays = sessionStorage.getItem('freedays');
    console.log(this.selectedDates);
    console.log(this.free);
    console.log(this.frees);
    console.log(this.freedays);
    console.log(this.displayadModel.noOfAdDays);
    console.log(this.displayadModel.boxcharge);

    this.displayadModel.freedays = this.freedays;
    this.displayadModel.selectedDate = this.selectedDates;
    this.displayadModel.noofdays = this.displayadModel.noOfAdDays;
    if (this.displayadModel.freedays === 1) {
    this.displayadModel.free = this.free;
    }
    if (this.displayadModel.freedays === 2) {
      this.displayadModel.free = this.free;
      this.displayadModel.frees = this.frees;
  }
    console.log(this.displayadModel.location);
    if (this.displayadModel.location === 'Meghalaya') {
      if (this.displayadModel.boxcharge !== true) {
    if (this.displayadModel.adcost) {
     this.cost = parseFloat(this.displayadModel.adcost) * parseFloat(this.displayadModel.noOfAdDays);
     this.displayadModel.cgst = (parseFloat(this.cost) * 2.5 / 100).toFixed(2);
     this.displayadModel.sgst = (parseFloat(this.cost) * 2.5 / 100).toFixed(2);

     this.displayadModel.totalCost = (parseFloat(this.cost) +
      parseFloat(this.displayadModel.cgst) + parseFloat(this.displayadModel.sgst)).toFixed(2);


     sessionStorage.setItem('Array', JSON.stringify(this.displayadModel));

     this.addata.setAdData(this.displayadModel);
    }
  }

      if (this.displayadModel.boxcharge === true) {
  if (this.displayadModel.adcost) {
    this.cost = (parseFloat(this.displayadModel.adcost) * parseFloat(this.displayadModel.noOfAdDays) + 30);
    this.displayadModel.cgst = (parseFloat(this.cost) * 2.5 / 100).toFixed(2);
    this.displayadModel.sgst = (parseFloat(this.cost) * 2.5 / 100).toFixed(2);

    this.displayadModel.totalCost = ( parseFloat(this.cost) +
     parseFloat(this.displayadModel.cgst) + parseFloat(this.displayadModel.sgst)).toFixed(2);


    sessionStorage.setItem('Array', JSON.stringify(this.displayadModel));

    this.addata.setAdData(this.displayadModel);
   }
}
      if (this.displayadModel.boxcharge === true && this.displayadModel.postalcharge === true) {
  this.cost = (parseFloat(this.displayadModel.adcost) * parseFloat(this.displayadModel.noOfAdDays) + 30 + 100);
  this.displayadModel.cgst = (parseFloat(this.cost) * 2.5 / 100).toFixed(2);
  this.displayadModel.sgst = (parseFloat(this.cost) * 2.5 / 100).toFixed(2);

  this.displayadModel.totalCost = (parseFloat(this.cost) +
     parseFloat(this.displayadModel.cgst) + parseFloat(this.displayadModel.sgst) ).toFixed(2);

     // this.displayadModel.basicrate = this.displayadModel.customrado;
  sessionStorage.setItem('Array', JSON.stringify(this.displayadModel));

  this.addata.setAdData(this.displayadModel);
}

}

    if (this.displayadModel.location !== 'Meghalaya') {
  if (this.displayadModel.boxcharge !== true) {
if (this.displayadModel.adcost) {
 this.cost = parseFloat(this.displayadModel.adcost) * parseFloat(this.displayadModel.noOfAdDays);
 this.displayadModel.igst = (parseFloat(this.cost) * 5.00 / 100).toFixed(2);


 this.displayadModel.totalCost = (parseFloat(this.displayadModel.igst) + parseFloat(this.cost)).toFixed(2);

  // this.displayadModel.basicrate = this.displayadModel.customrado;
 sessionStorage.setItem('Array', JSON.stringify(this.displayadModel));

 this.addata.setAdData(this.displayadModel);
}
}

  if (this.displayadModel.boxcharge === true) {
if (this.displayadModel.adcost) {
this.cost = (parseFloat(this.displayadModel.adcost) * parseFloat(this.displayadModel.noOfAdDays)  + 30);
this.displayadModel.igst = (parseFloat(this.cost) * 5.00 / 100).toFixed(2);

this.displayadModel.totalCost = (parseFloat(this.displayadModel.igst) + parseFloat(this.cost)).toFixed(2);

 // this.displayadModel.basicrate = this.displayadModel.customrado;
sessionStorage.setItem('Array', JSON.stringify(this.displayadModel));

this.addata.setAdData(this.displayadModel);
}
}
  if (this.displayadModel.boxcharge === true && this.displayadModel.postalcharge === true) {
this.cost = (parseFloat(this.displayadModel.adcost) * parseFloat(this.displayadModel.noOfAdDays)  + 30 + 100);
this.displayadModel.igst = (parseFloat(this.cost) * 5.00 / 100).toFixed(2);


this.displayadModel.totalCost = (parseFloat(this.displayadModel.igst) + parseFloat(this.cost)).toFixed(2);

 // this.displayadModel.basicrate = this.displayadModel.customrado;
sessionStorage.setItem('Array', JSON.stringify(this.displayadModel));

this.addata.setAdData(this.displayadModel);
}

}
  }


  pay() {
    if (this.userdataservice.getUserData() == null) {
      this.router.navigate(['/register']);
    } else {
      this.router.navigate(['/paymentmethod1']);
    }

  }

  ngOnInit() {

    this.displayadModel = JSON.parse(sessionStorage.getItem('Array'));
    const obj = this.addata.getAdData();
    this.displayadModel = (obj) ? obj : this.adDetails;
    console.log(obj);
    // this.displayadModel.custid = this.userdataservice.getUserData().custid;
    // this.displayadModel.email = this.userdataservice.getUserData().email;
  }

  ngOnDestroy() {
    // this.userdataservice.getUserData().unsubscribe();
  }

  async paynow() {
    this.displayadModel.custid = this.userdataservice.getUserData().custid;
    this.displayadModel.email = this.userdataservice.getUserData().email;
    if (this.userdataservice.getUserData().isGuest) {
      this.saveGuestDetails();
    } else {
      this.saveAdBookingDetails();
    }
  }

  saveGuestDetails() {
    this.adbookingService.saveGuestDetails(this.userdataservice.getUserData()).subscribe(resp => {
      if (resp.status === 'Success') {
        this.displayadModel.guestid = resp.data.id;
        resp.data.isGuest = true;
        this.userdata.setUserData(resp.data);
        this.saveAdBookingDetails();
        // this.saveCard();
      }
    });
  }

  async saveAdBookingDetails() {
    // alert("adbooking Details function");
    this.adbookingService.saveAdBookingDetails(this.displayadModel).subscribe(
      data => {
        console.log(data);
        this.displayadModel.orderid = data.orderid;
        console.log(this.displayadModel.orderid);
        sessionStorage.setItem('Array', JSON.stringify(this.displayadModel));
        this.saveAdDates();
        if (this.displayadModel.fileData) {
          this.fileSave(data.orderid);
        }
        //  sessionStorage.setItem("orderid", this.displayadModel);
        // this.displayadModel = data;
        // sessionStorage.setItem("Array", JSON.stringify(this.displayadModel));
        //  error => console.log(error)
      },
      error => console.log(error)
    );
  }
  saveAdDates() {
    this.adbookingService.saveAdDates(this.displayadModel).subscribe(
      data => {
        console.log(data);

        this.saveAdPayments();
        // this.displayadModel = data;
        // sessionStorage.setItem("Array", JSON.stringify(this.displayadModel));
        //  error => console.log(error)
      },
      error => console.log(error)
    );
  }

  saveAdPayments() {
    this.adbookingService.saveAdPayments(this.displayadModel).subscribe(
      data => {
        console.log(data);
        // sessionStorage.clear();
        // this.router.navigate(['/adconfirmation1']);
        // this.displayadModel = data;
        // sessionStorage.setItem("Array", JSON.stringify(this.displayadModel));
        //  error => console.log(error)
      },
      error => console.log(error)
    );
  }

  saveFiles() {
    const formData = new FormData();
    console.log(this.displayadModel.fileData);

    formData.append('myfile', this.displayadModel.fileData);
    // alert("From saveFiles:" + this.displayadModel.fileData);
    // alert("From saveFiles name:" + this.displayadModel.imagename);
    this.displayadModel.flagdate = false;
    this.fileservice.saveFile(formData).subscribe(
      data => {
        console.log(data);
      },
      error => console.log(error)
    );
  }

  fileSave(id) {
    console.log(this.userdataservice.getUserData());
    this.displayadModel.address = this.userdataservice.getUserData().address;
    this.displayadModel.isGuest = this.userdataservice.getUserData().isGuest;
    this.displayadModel.username = this.userdataservice.getUserData().username;
    this.displayadModel.email = this.userdataservice.getUserData().email;
    this.displayadModel.mobilenumber = this.userdataservice.getUserData().mobilenumber;
    this.displayadModel.state = this.userdataservice.getUserData().state;
    this.displayadModel.city = this.userdataservice.getUserData().city;
    this.displayadModel.zip = this.userdataservice.getUserData().zip;
    this.displayadModel.country = 'India';
    console.log(this.displayadModel);
    setTimeout(() => {
      $('#payformsubmit').trigger('click');
    }, 1000);

  }
}
